import React from "react";
import { Typography, ToggleButtonGroup, Box, ToggleButton, Divider } from "@mui/material";
import BaseModal from "./BaseModal";
import GradientCard from "../gradients/GradientCard";
import GradientButton from "../gradients/GradientButton";
import ShopifyGetPatchPointsPacks from "../../utils/ShopifyGetPatchPointsPacks";
import BaseDrawer from "./mobile/BaseDrawer";

export const PurchasePatchPointsModal = ({ onClose, handleAddPatchPoints, isMobile }) => {
  const [options, setOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState();

  const Modal = isMobile ? BaseDrawer : BaseModal;

  React.useEffect(() => {
    ShopifyGetPatchPointsPacks().then((products) => {
      const mapped = products.map((product, index) => {
        switch (index) {
          case 0:
            product.background = "#B194BD";
            break;
          case 5:
            product.background = "#3982B8";
            break;
          case 1:
          case 4:
            product.background = "#EB50A2";
            break;
          case 2:
          case 7:
            product.background = "#ECDD83";
            break;
          case 3:
          case 6:
            product.background = "#A5DCE2";
            break;
        }
        return product;
      });
      setOptions(mapped);
      setSelectedOption(mapped[4]);
    });
  }, []);

  const handleChangeSelectedOption = (event, value) => {
    if (value) {
      setSelectedOption(value);
    }
  };

  const handleSubmit = () => {
    handleAddPatchPoints(selectedOption);
    onClose();
  };

  return (
    <Modal headline="Patch Points Packs" onClose={onClose} gradient={true}>
      <Typography sx={{ textAlign: "center", marginBottom: "10px", fontSize: "18px" }}>
        Buy Extra Patch Points to Boost Your Design
      </Typography>
      <ToggleButtonGroup
        exclusive
        value={selectedOption}
        sx={{
          display: "grid",
          grid: `auto/repeat(${isMobile ? "3" : "4"}, 1fr)`,
          columnGap: "10px",
          rowGap: isMobile ? "15px" : " 5px",
          maxWidth: "430px",
          margin: "0px auto",
        }}
        onChange={handleChangeSelectedOption}
      >
        {options.map((option, index) => (
          <ToggleButton
            key={index}
            value={option}
            sx={{
              background: "transparent !important",
              border: "none !important",
              padding: "0px",
            }}
          >
            <Box
              sx={{
                width: "100px",
                height: "100px",
              }}
            >
              <GradientCard
                variant="circle"
                selected={selectedOption === option}
                sx={{
                  borderColor: "#ffffff !important",
                  "& > .MuiCard-root": {
                    backgroundColor: option.background,
                    border: "3px solid",
                    borderColor: selectedOption === option ? "#ffffff" : "#000000",
                  },
                }}
              >
                <img src={option.src} style={{ marginBottom: "-15px" }} />
                <div style={{ marginTop: "-3px" }}>${option.price.toFixed(2)}</div>
              </GradientCard>
            </Box>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <Divider sx={{ margin: "10px 0px" }} />
      <Box sx={{ textAlign: "center" }}>
        <Typography sx={{ fontSize: "24px", fontWeight: "700" }}>
          ${selectedOption && selectedOption.price.toFixed(2)}
        </Typography>
      </Box>
      <Box sx={{ textAlign: "center", marginTop: "10px" }}>
        <GradientButton addStyle={{ minHeight: "45px", fontSize: "15px" }} onClick={handleSubmit}>
          Add to Cart
        </GradientButton>
      </Box>
    </Modal>
  );
};

export default PurchasePatchPointsModal;
